import { ref } from "vue";
import { useFetch } from "@/composables/fetch";
import { useOptions } from "@/composables/options";
import { useParamsStore } from "@/stores/commons/paramsStore";
import { Options } from "@/types/params";
import { setHotelParams, setKinboo2Params } from "@/utils/setWcParams";
export const wcInit = (props: any) => {
	const displayData: any = ref(null);
	const { HUBCORE_URL_RO, HUBCORE_USR, HUBCORE_PWD } = useOptions();
	const WcData: any = ref(null);
	const fetchDisplayData = async (props: any) => {
		const endPoint = "/webrest/displayApiController/getDisplay";
		try {
			const { data } = await useFetch({
				url: `${HUBCORE_URL_RO}${endPoint}`,
				params: {
					method: "POST",
					auth: {
						username: HUBCORE_USR,
						password: HUBCORE_PWD
					},
					data: {
						display_id: props.display,
						lang: props.lang
					}
				}
			});
			displayData.value = data;

			let wl_widgets_config: any = displayData.value?.wl_widgets_config;

			return wl_widgets_config &&
				wl_widgets_config.dynamicWidgetsWebsiteEnabled === true
				? isActive(wl_widgets_config, props.type)
				: null;
		} catch (error) {
			console.error("Error in fetchDisplayData ", error);
		}
	};

	const isActive = (wl_widgets_config: any, type: string) => {
		let res: any = null;
		let disabled: String = "disabled";
		switch (type) {
			case "experience":
				res =
					wl_widgets_config.experienceFunnelEnabled === true ? type : disabled;
				break;
			case "viaggismart":
				res =
					wl_widgets_config.travelIdeasFunnelEnabled === true ? type : disabled;
				break;
			case "hotels":
				res = wl_widgets_config.hotelFunnelEnabled === true ? type : disabled;
				break;
		}
		if (res !== disabled) {
			setHcParams(wl_widgets_config, type);
		}
		return res;
	};

	const setHcParams = (wl_widgets_config: any, type: string) => {
		const kinboo2Config = wl_widgets_config.kinboo2Config;
		let params = setKinboo2Params(
			kinboo2Config,
			type,
			props.lang,
			wl_widgets_config.region
		);

		let customParams: Options = { ...params, ...props.options };
		WcData.value = {
			display: props.display,
			lang: props.lang,
			type: props.type,
			options: customParams,
			client: props.client,
			magic: props.magic
		};

		const paramsStore = useParamsStore();
		paramsStore.setParams(WcData.value);

		document
			.querySelector("html")
			?.setAttribute("data-theme", WcData.value.options.theme || "default");
	};

	return {
		displayData,
		fetchDisplayData
	};
};
